import React, { Fragment } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTheme } from "@mui/material/styles";
import { emailUserTargetTypes } from "./notificationConstant";
import { getNotificationCountrySelectOptions } from "./notificationFormUtils";
import { selectMenuProps } from "../../utils/selectMenuProps";
import { useDesignTokens } from "../../theme/useDesignTokens";
import FormInput from "../Common/FormInputs/MuiTextField";
import {
  emailFieldRowSx,
  emailFormControlSx,
  emailFocusOutlineSx,
  emailSectionCardSx,
} from "./emailFormStyles";

const EmailUserSelection = ({
  userTargetType,
  handleUserTargetTypeChange,
  country = "None",
  handleCountryChange,
  allowedCountries = [],
  userIdCSVFileInputRef,
  handleUserIdFileInput,
  uploadedUserIdFileInput = "",
}) => {
  const theme = useTheme();
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main || theme.palette.primary.main;
  const focusOutlineSx = emailFocusOutlineSx(primaryColor);

  const countryOptions = getNotificationCountrySelectOptions(allowedCountries);
  const isBroadcast = userTargetType === emailUserTargetTypes.broadcast.value;
  const isTargeted = userTargetType === emailUserTargetTypes.targeted.value;

  return (
    <Fragment>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
        Users
      </Typography>
      <Paper sx={emailSectionCardSx}>
        <Box sx={{ ...emailFieldRowSx, alignItems: { xs: "start", md: "center" } }}>
          <Typography variant="body2" sx={{ fontWeight: 400 }}>
            User Type:
          </Typography>
          <Box>
            <RadioGroup
              row
              value={userTargetType}
              onChange={(e) => handleUserTargetTypeChange(e.target.value)}
              sx={{ gap: { xs: 0, sm: 2 }, flexWrap: "wrap" }}
            >
              <FormControlLabel
                value={emailUserTargetTypes.broadcast.value}
                control={<Radio size="small" color="primary" />}
                label={emailUserTargetTypes.broadcast.label}
              />
              <FormControlLabel
                value={emailUserTargetTypes.targeted.value}
                control={<Radio size="small" color="primary" />}
                label={emailUserTargetTypes.targeted.label}
              />
            </RadioGroup>
          </Box>
        </Box>

        {isBroadcast && (
          <Box sx={emailFieldRowSx}>
            <Typography variant="body2" sx={{ fontWeight: 400 }}>
              Country:
            </Typography>
            <Box sx={emailFormControlSx(theme)}>
              <FormInput
                id="select-outlined-country-name-id"
                type="select"
                size="small"
                fullWidth
                name="country"
                value={country}
                onChange={(e) => handleCountryChange(e.target.value)}
                displayEmpty
                renderValue={(value) => (!value ? "Select Country" : value)}
                MenuProps={selectMenuProps}
                options={countryOptions}
                sx={focusOutlineSx}
              />
            </Box>
          </Box>
        )}

        {isTargeted && (
          <Box sx={emailFieldRowSx}>
            <Typography variant="body2" sx={{ fontWeight: 400 }}>
              Upload User Ids CSV File:
            </Typography>
            <Box sx={emailFormControlSx(theme)}>
              <FormInput
                type="file"
                size="small"
                fullWidth
                accept=".csv"
                name={uploadedUserIdFileInput?.name ?? uploadedUserIdFileInput}
                inputRef={userIdCSVFileInputRef}
                onChange={(e) => handleUserIdFileInput(e.target.files?.[0])}
                sx={focusOutlineSx}
              />
            </Box>
          </Box>
        )}
      </Paper>
    </Fragment>
  );
};

export default EmailUserSelection;
